import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import {
  USER_SIGNUP_STARTED,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAIL,
  USER_SIGNUP_FINISHED,
  USER_LOGIN_STARTED,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_2FA_LOGIN_STARTED,
  USER_2FA_LOGIN_FAILED,
  USER_LOGOUT_STARTED,
  USER_FORGOT_PASSWORD_STARTED,
  USER_FORGOT_PASSWORD_SUCCESS,
  USER_FORGOT_PASSWORD_FAIL,
  USER_CHANGE_PASSWORD_OTP_STARTED,
  USER_CHANGE_PASSWORD_OTP_SUCCESS,
  USER_CHANGE_PASSWORD_OTP_FAIL,
  USER_CHANGE_PASSWORD_OTP_LOADING,
  USER_CHANGE_PASSWORD_STARTED,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAIL,
  USER_CHANGE_PASSWORD_FINISHED,
  USER_EMAIL_VERIFICATION_STARTED,
  USER_EMAIL_VERIFICATION_SUCCESS,
  USER_EMAIL_VERIFICATION_FAIL,
  LOAD_PROFILE_STARTED,
  LOAD_PROFILE_SUCCESS,
  LOAD_PROFILE_FAIL,
  LOAD_LOGIN_HISTORY_STARTED,
  LOAD_LOGIN_HISTORY_SUCCESS,
  LOAD_LOGIN_HISTORY_FAIL,
  LOAD_FEE_DISCOUNT_STATUS_STARTED,
  LOAD_FEE_DISCOUNT_STATUS_SUCCESS,
  LOAD_FEE_DISCOUNT_STATUS_FAIL,
  LOAD_COPY_TRADING_ENROLLMENT_STATUS,
  LOAD_COPY_TRADING_USER_TRADERS,
  LOAD_COPY_TRADING_USER_TRADERS_STARTED,
  SET_ADDITIONAL_FIELDS_REQUIREMENT,
  LOAD_ADDITIONAL_FIELDS_SUCCESS,
  LOAD_TRADING_VOLUME_DISCOUNTS_SUCCESS,
} from 'redux/actions/profile';

import { GET_AFFILIATE_SUMMARY, GET_AFFILIATE_REFERRALS, GET_AFFILIATE_COMMISSION } from 'redux/actions/affiliate';

import { GET_IPWHITELISTING, GET_DEVICEWHITELISTING } from 'redux/actions/ipwhitelisting';

import { GET_USER_TEMP_AUTH_TOKEN, USER_NOT_AUTHENTICATED, USER_AUTHENTICATED } from 'redux/reducers/auth';

import { GET_API_KEYS, DELETE_API_KEY } from 'redux/actions/apiKeys';

import { GENERATE_KYC_KEYS } from 'redux/actions/kyc';

const affilateInitialState = {
  affiliateInfo: {
    summary: {},
    affiliates: [],
    commission: [],
  },
};

const initialState = {
  ...affilateInitialState,
  isLoading: false,
  isLoginLoading: false,
  is2FALoginLoading: false,
  isProfileLoading: false,
  signupStarted: false,
  passwordChanged: false,
  passwordChangedOTP: undefined,
  passwordResetStarted: false,
  passwordResetCompleted: false,
  emailVerificationCompleted: false,
  profile: {
    loginHistory: [],
  },

  ipwhitelistingInfo: [],
  devicewhitelistingInfo: [],
  apiKeys: [],
  kycKeys: {},
  tradingDiscountTiers: [],
  feeDiscountStatus: false,
  copyTradingEnrollmentStatus: false,
  copyTradingFollowing: {},
  isCopyTradingLoading: true,
  additionalFieldsRequired: false,
  additionalAccountFields: [],
};

const handleLoading = (state) => ({
  ...state,
  isLoading: true,
});

const handleFailure = (state) => ({
  ...state,
  isLoading: false,
});

const handleAffilateSummarySuccess = (state, action) => ({
  ...state,
  isLoading: false,
  affiliateInfo: {
    ...state.affiliateInfo,
    summary: action.payload,
  },
});

export const initialUserReducer = (state = initialState, action) => {
  switch (action.type) {
    //* SIGN UP
    case USER_SIGNUP_STARTED:
      return { ...state, isloading: true, signupStarted: false };
    case USER_SIGNUP_SUCCESS:
      return { ...state, isloading: false, signupStarted: true };
    case USER_SIGNUP_FINISHED:
      return { ...state, isloading: false, signupStarted: false };
    case USER_SIGNUP_FAIL:
      return { ...state, isloading: false, signupStarted: false };

    //* EMAIL VERIFICATION
    case USER_EMAIL_VERIFICATION_STARTED:
      return {
        ...state,
        isLoading: true,
        emailVerificationCompleted: false,
      };
    case USER_EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailVerificationCompleted: true,
      };
    case USER_EMAIL_VERIFICATION_FAIL: {
      return {
        ...state,
        isLoading: false,
        emailVerificationCompleted: false,
      };
    }

    //* LOGIN
    case USER_LOGIN_STARTED:
      return { ...state, isLoginLoading: true };
    case USER_LOGIN_SUCCESS:
      return { ...state, isLoginLoading: false, is2FALoginLoading: false };
    case USER_LOGIN_FAIL:
      return { ...state, isLoginLoading: false };
    case GET_USER_TEMP_AUTH_TOKEN:
      return { ...state, isLoginLoading: false };

    //* 2FA LOGIN
    case USER_2FA_LOGIN_STARTED:
      return { ...state, is2FALoginLoading: true };
    case USER_2FA_LOGIN_FAILED:
      return { ...state, is2FALoginLoading: false };
    case USER_AUTHENTICATED:
      return { ...state, is2FALoginLoading: false };
    case USER_NOT_AUTHENTICATED:
      return { ...initialState };

    //* LOAD PROFILE
    case LOAD_PROFILE_STARTED:
      return { ...state, isProfileLoading: true };
    case LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        isProfileLoading: false,
        profile: {
          ...action.payload,
          loginHistory: [...state.profile.loginHistory],
        },
      };
    case LOAD_PROFILE_FAIL:
      return { ...state, isProfileLoading: false };

    //* LOGIN HISTORY
    case LOAD_LOGIN_HISTORY_STARTED:
      return { ...state, isLoading: true };
    case LOAD_LOGIN_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profile: {
          ...state.profile,
          loginHistory: action.payload,
        },
      };
    case LOAD_LOGIN_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    //* API KEYS

    // List all
    case GET_API_KEYS.STARTED:
      return { ...state, isLoading: true };
    case GET_API_KEYS.SUCCESS:
      return { ...state, isLoading: false, apiKeys: action.payload };
    case GET_API_KEYS.FAIL:
      return { ...state, isLoading: false };

    // Delete existing
    case DELETE_API_KEY.STARTED:
      return { ...state, isLoading: true };
    case DELETE_API_KEY.SUCCESS:
      return {
        ...state,
        isLoading: false,
        apiKeys: state.apiKeys.filter(({ key }) => key !== action.payload),
      };
    case DELETE_API_KEY.FAIL:
      return { ...state, isLoading: false };

    //* API KEYS

    // List all
    case GENERATE_KYC_KEYS.STARTED:
      return { ...state, isLoading: true };
    case GENERATE_KYC_KEYS.SUCCESS:
      return { ...state, isLoading: false, kycKeys: action.payload };
    case GENERATE_KYC_KEYS.FAIL:
      return { ...state, isLoading: false };

    //* AFFILIATE SUMMARY
    case GET_AFFILIATE_SUMMARY.STARTED:
      return handleLoading(state);
    case GET_AFFILIATE_SUMMARY.SUCCESS:
      return handleAffilateSummarySuccess(state, action);
    case GET_AFFILIATE_SUMMARY.FAIL:
      return handleFailure(state);

    //* AFFILIATE REFERRALS (AFFILIATES)
    case GET_AFFILIATE_REFERRALS.STARTED:
      return { ...state, isloading: true };
    case GET_AFFILIATE_REFERRALS.SUCCESS:
      return {
        ...state,
        isloading: false,
        affiliateInfo: {
          ...state.affiliateInfo,
          affiliates: action.payload,
        },
      };
    case GET_AFFILIATE_REFERRALS.FAIL:
      return { ...state, isloading: false };

    //* AFFILIATE COMMISIONS
    case GET_AFFILIATE_COMMISSION.STARTED:
      return { ...state, isloading: true };
    case GET_AFFILIATE_COMMISSION.SUCCESS:
      return {
        ...state,
        isloading: false,
        affiliateInfo: {
          ...state.affiliateInfo,
          commission: action.payload,
        },
      };
    case GET_AFFILIATE_COMMISSION.FAIL:
      return { ...state, isloading: false };

    // IPWHITELISTING DATA
    case GET_IPWHITELISTING.STARTED:
      return { ...state, isloading: true };
    case GET_IPWHITELISTING.SUCCESS:
      return {
        ...state,
        isloading: false,
        ipwhitelistingInfo: action.payload,
      };
    case GET_IPWHITELISTING.FAIL:
      return { ...state, isloading: false };

    // DEVICEWHITELISTING DATA
    case GET_DEVICEWHITELISTING.STARTED:
      return { ...state, isloading: true };
    case GET_DEVICEWHITELISTING.SUCCESS:
      return {
        ...state,
        isloading: false,
        devicewhitelistingInfo: action.payload,
      };
    case GET_DEVICEWHITELISTING.FAIL:
      return { ...state, isloading: false };

    //* LOAD FEES
    case LOAD_FEE_DISCOUNT_STATUS_STARTED:
      return { ...state, isLoading: true };
    case LOAD_FEE_DISCOUNT_STATUS_FAIL:
      return { ...state, isLoading: false };
    case LOAD_FEE_DISCOUNT_STATUS_SUCCESS:
      return { ...state, isLoading: false, feeDiscountStatus: action.payload };
    case LOAD_TRADING_VOLUME_DISCOUNTS_SUCCESS:
      return { ...state, tradingDiscountTiers: action.payload };

    case LOAD_COPY_TRADING_ENROLLMENT_STATUS:
      return { ...state, copyTradingEnrollmentStatus: action.payload };
    case LOAD_COPY_TRADING_USER_TRADERS_STARTED:
      return { ...state, isCopyTradingLoading: true };
    case LOAD_COPY_TRADING_USER_TRADERS:
      return {
        ...state,
        copyTradingFollowing: action.payload,
        isCopyTradingLoading: false,
      };

    //* CHANGE PASSWORD
    case USER_CHANGE_PASSWORD_OTP_STARTED:
      return { ...state, isLoading: true, passwordChangedOTP: false };
    case USER_CHANGE_PASSWORD_OTP_SUCCESS:
      return { ...state, isLoading: false, passwordChangedOTP: true };
    case USER_CHANGE_PASSWORD_OTP_FAIL:
      return { ...state, isLoading: false, passwordChangedOTP: false };
    case USER_CHANGE_PASSWORD_OTP_LOADING:
      return { ...state, isLoading: true };

    case USER_CHANGE_PASSWORD_STARTED:
      return { ...state, isLoading: true, passwordChanged: false };
    case USER_CHANGE_PASSWORD_SUCCESS:
      return { ...state, isLoading: false, passwordChanged: true };
    case USER_CHANGE_PASSWORD_FAIL:
      return { ...state, isLoading: false, passwordChanged: false };
    case USER_CHANGE_PASSWORD_FINISHED:
      return {
        ...state,
        isLoading: false,
        passwordChanged: false,
        passwordChangedOTP: false,
      };

    //* FORGOT PASSWORD
    case USER_FORGOT_PASSWORD_STARTED:
      return {
        ...state,
        isLoading: true,
        passwordResetStarted: false,
        passwordResetCompleted: false,
      };
    case USER_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        passwordResetStarted: true,
        passwordResetCompleted: false,
      };
    case USER_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false,
        passwordResetStarted: false,
        passwordResetCompleted: false,
      };

    //* LOGOUT
    case USER_LOGOUT_STARTED:
      return { ...initialState };

    // ADDITIONAL FIELDS
    case SET_ADDITIONAL_FIELDS_REQUIREMENT:
      return { ...state, additionalFieldsRequired: action.payload };
    case LOAD_ADDITIONAL_FIELDS_SUCCESS:
      return { ...state, additionalAccountFields: action.payload };

    //* DEFAULT
    default:
      return state;
  }
};

const persistConfig = {
  key: 'user',
  storage: storage,
  whitelist: ['profile'],
};

export const userReducer = persistReducer(persistConfig, initialUserReducer);
